module.exports = __webpack_public_path__ + "img/git-commit.a7c93233.svg";